import { useReducer } from "react";
import { API, graphqlOperation } from "aws-amplify";
import * as Sentry from "@sentry/react";
/* eslint-disable */

export interface Action {
  type: string;
  payload?: {
    data?: unknown;
    params?: any;
    input?: unknown;
    error?: unknown;
    function?: unknown;
  };
}
export interface State {
  accessToken: string;
}

export const useReducerWithGraphEnhancedDispatch = <T, K>(args: {
  converter?: <T>(data: T) => T;
  reducer: React.Reducer<T, K>;
  initialState: T;
}): [T, React.Dispatch<K>] => {
  const [reduceState, dispatch] = useReducer(args.reducer, args.initialState);

  const dispatchEnhanced = async (ac: unknown) => {
    const action = ac as K & Action;
    if (!action.payload || !action.payload.function) {
      dispatch(action);
      return;
    }
    const beginType = action.type;
    const successType = `${action.type}_SUCCESS`;
    const failType = `${action.type}_FAILURE`;
    const startAction = { type: beginType, payload: action.payload } as K &
      Action;
    dispatch(startAction);

    try {
      const res = (await API.graphql(
        graphqlOperation(action.payload.function, action.payload?.params)
      )) as any;
      const successAction = {
        payload: {
          data: args.converter ? args.converter(res.data) : res.data,
        },
        type: successType,
      } as K & Action;
      dispatch(successAction);
      return;
    } catch (error: any) {
      const failAction = {
        payload: {
          error: {
            code: "",
            message:
              error?.errors && error?.errors[0]
                ? error?.errors[0]?.message
                : "",
          },
        },
        type: failType,
      } as K & Action;
      Sentry.captureException({
        message:
          error?.errors && error?.errors[0] ? error?.errors[0]?.message : "",
        data: JSON.stringify(action.payload),
      });
      dispatch(failAction);
    }
  };

  return [reduceState, dispatchEnhanced];
};
